"use client";
import { memo } from "react";
import { CrystallizeImage } from "./CrystallizeImage";
import Link from "~/bridge/ui/Link";
import { useAppContext } from "../../app-context/provider";
import displayPriceFor from "~/use-cases/checkout/pricing";
import { Price } from "../price";
import { ProductSlim } from "~/use-cases/contracts/Product";
import { DataMapper } from "~/use-cases/mapper";
import PlaceholderImg from "~/assets/product.svg";
import { AddToCartBtnSimple } from "../add-to-cart-button-simple";
import Image from "next/image";
import LipscoreReviewSmall from "../aplia/Lipscore/LipScoreReviewSmall";

export const Product: React.FC<{ item: ProductSlim; priority?: boolean }> = memo(({ item, priority = false }) => {
  const { state, path } = useAppContext();
  const { percent: discountPercentage } = displayPriceFor(
    item.variant,
    {
      default: "default",
      discounted: "sales",
    },
    state.currency.code,
  );
  const attributesKeys = Object.keys(item.variant.attributes ?? {});
  // only append SKU if multiple variants
  let sku = "";
  if (item.hasMultipleVariants && item.variant?.sku) {
    sku = "?sku=" + item.variant.sku;
  }


  return (
    <div className="min-h-full relative product-grid-item flex flex-col justify-between">
      <Link
        to={path(item.path + sku)}
        data-testid="product-link"
        prefetch="intent"
        className="grid product-link w-full"
      >
        {discountPercentage > 0 && (
          <div className="product__discount absolute items-center flex z-20 justify-center rounded-full w-[85px] h-[85px] text-white">
            <div className="product__discount__data">
              -{discountPercentage}%
            </div>
          </div>
        )}
        <div className="img-container img-contain aspect-4/3 h-full overflow-hidden grow">
          {item?.variant?.images[0] ? (
            <CrystallizeImage
              {...item?.variant?.images[0]}
              sizes="(max-width: 640px) 50vw, (max-width: 1280px) 33vw, 20vw"
              loading={priority ? "eager" : "lazy"}
              fallbackAlt={item?.name}
              key={item?.name}
            />
          ) : (
            <Image
              src={PlaceholderImg}
              alt={item.name}
              width="100"
              height="100"
            />
          )}
        </div>
        <div className="pl-1 pt-4">
          <p className="text-md font-bold font line-clamp-2 overflow-hidden mb-2 min-h-[3em]">
            {item.name}
          </p>
        </div>
        {/* {attributesKeys.length > 0 && (
          <div className="flex gap-3 my-2">
            {attributesKeys.map((key) => (
              <div className="text-xs bg-grey py-1 px-3 rounded-sm" key={key}>
                {item.variant.attributes[key]}
              </div>
            ))}
          </div>
        )} */}
        <LipscoreReviewSmall product={item} />
        <div className="pl-1">
          <Price variant={item.variant} size="small" />
        </div>
      </Link>
      <div className="buy">
        {item.variant.outofstock.content?.value === true ? (
          <div className="pt-10 text-red-900">Tomt på lager</div>
        ) : (
          <AddToCartBtnSimple
            pack={[{ variant: item.variant, quantity: 1 }]}
            label="Kjøp"
          />
        )}
      </div>
    </div>
  );
});

Product.displayName = "Product";

export const ProductFromCell: React.FC<{ item: any }> = ({ item }) => {
  const mapper = DataMapper();
  const productVariant = mapper.API.Object.APIProductVariantToProductVariant(
    item.defaultVariant,
  );

  return (
    <Product
      item={{
        id: item.id,
        name: item.name,
        path: item.path,
        variant: productVariant,
        topics: [],
        sku: item.sku,
        brand: item.brand,
      }}
    />
  );
};
